/**
 *
 * This API is wrapped because it is not supported by all browser properly yet.
 * We try to use the API whenever we can, but provide a nodejs fallback for users that don't support it.
 */
function getAllTimeZones(): string[] {
  if ("supportedValuesOf" in Intl && typeof (Intl as any).supportedValuesOf === "function") {
    return (Intl as any).supportedValuesOf("timeZone");
  } else {
    return [];
  }
}

export const ALL_TIMEZONES = getAllTimeZones();
